import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: 800,
      position: "relative",
      left: "50%",
      marginLeft: -400,
    }
  }
})

const FormContainer = ({ classes, children }) => (
  <div className={classes.root}>
    {children}
  </div>
);

export default withStyles(styles)(FormContainer)